import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal, Typography } from 'seagull';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ContactErrorResponse } from '~/infra/error-response/ContactErrorResponse';
import { errorTextsPath } from '~/infra/error-response/ErrorResponse';
import { contactStateKey } from '~/pages/ContactsDashboardOld/ContactsDashboardOld.utils';
const neverLastOwner = ()=>Promise.resolve(false);
export function useContactArchiveRestoreDelete(param) {
    let { onSuccess, bi, isLastOwner = neverLastOwner } = param;
    const { api } = useStoreActions();
    const { showModal, showSuccessToast, showErrorToast, startLoader, stopLoader } = useOverlayContext();
    const { t: contactsDashboardTexts } = useLocaleKeys('client.contactsDashboardOld');
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const deleteConfirmationContent = async (contact, stateKey)=>{
        const content = await isLastOwner(contact) ? contactsDashboardTexts.deleteConfirmation.content.lastOwner[stateKey] : contactsDashboardTexts.deleteConfirmation.content[stateKey];
        return content({
            fullName: contact.fullName()
        });
    };
    const onDelete = async (contact)=>{
        try {
            var _bi_delete_onMenuClick, _bi_delete;
            bi === null || bi === void 0 ? void 0 : (_bi_delete = bi.delete) === null || _bi_delete === void 0 ? void 0 : (_bi_delete_onMenuClick = _bi_delete.onMenuClick) === null || _bi_delete_onMenuClick === void 0 ? void 0 : _bi_delete_onMenuClick.call(_bi_delete, contact);
            const stateKey = contactStateKey(contact);
            const content = await deleteConfirmationContent(contact, stateKey);
            const confirmed = await showModal({
                biName: 'contacts_dashboard_delete_confirmation_ke_confirm',
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(ConfirmationModal, {
                        bi: {
                            primaryButton: {
                                name: 'contacts_3_confirm'
                            },
                            secondaryButton: {
                                name: 'contacts_3_cancel'
                            }
                        },
                        skin: "danger",
                        textAlignCenter: false,
                        title: contactsDashboardTexts.deleteConfirmation.title[stateKey](),
                        content: /*#__PURE__*/ _jsx(Typography, {
                            showWhiteSpaces: true,
                            children: content
                        }),
                        primaryButtonLabel: contactsDashboardTexts.deleteConfirmation.primaryButton(),
                        secondaryButtonLabel: contactsDashboardTexts.deleteConfirmation.secondaryButton(),
                        onPrimaryButtonClick: ()=>dismissModal(true),
                        onSecondaryButtonClick: ()=>{
                            var _bi_delete_onBack, _bi_delete;
                            bi === null || bi === void 0 ? void 0 : (_bi_delete = bi.delete) === null || _bi_delete === void 0 ? void 0 : (_bi_delete_onBack = _bi_delete.onBack) === null || _bi_delete_onBack === void 0 ? void 0 : _bi_delete_onBack.call(_bi_delete, contact);
                            dismissModal(false);
                        },
                        onCloseButtonClick: ()=>{
                            var _bi_delete_onClose, _bi_delete;
                            bi === null || bi === void 0 ? void 0 : (_bi_delete = bi.delete) === null || _bi_delete === void 0 ? void 0 : (_bi_delete_onClose = _bi_delete.onClose) === null || _bi_delete_onClose === void 0 ? void 0 : _bi_delete_onClose.call(_bi_delete, contact);
                            dismissModal(false);
                        }
                    });
                }
            });
            if (confirmed) {
                var _bi_delete_onConfirm, _bi_delete1, _bi_delete_onSuccess, _bi_delete2;
                bi === null || bi === void 0 ? void 0 : (_bi_delete1 = bi.delete) === null || _bi_delete1 === void 0 ? void 0 : (_bi_delete_onConfirm = _bi_delete1.onConfirm) === null || _bi_delete_onConfirm === void 0 ? void 0 : _bi_delete_onConfirm.call(_bi_delete1, contact);
                startLoader('delete-contact-loader');
                await api.contact.delete(contact.id());
                bi === null || bi === void 0 ? void 0 : (_bi_delete2 = bi.delete) === null || _bi_delete2 === void 0 ? void 0 : (_bi_delete_onSuccess = _bi_delete2.onSuccess) === null || _bi_delete_onSuccess === void 0 ? void 0 : _bi_delete_onSuccess.call(_bi_delete2, contact);
                showSuccessToast(contactsDashboardTexts.deleteSuccessToast(), 'delete-success-toast');
                await onSuccess();
            }
        } catch (err) {
            showErrorToast(new ContactErrorResponse(err).deleteMessage(errorTexts), 'delete-error-toast');
        } finally{
            stopLoader('delete-contact-loader');
        }
    };
    return {
        onDelete
    };
}
